var exports = {
  "M": "checkboxGrid__B3TmKa",
};

module.exports = exports;
